import React from 'react';
import PropTypes from 'prop-types';

import RenderGroup from '../../../components/Groups/RenderGroup/RenderGroup';
import { GroupPropTypesShape } from '../../../components/Includes/GroupPropsShape';
import SeeAllButton from './SeeAllButton';
import SectionHeader from './SectionHeader';

const GroupResults = ({
    results: { results: groups, total: groupTotal } = {},
    url,
    isSingleSearch,
}) => {
    if (!groupTotal) return null;

    const unit = groupTotal === 1 ? 'Group' : 'Groups';
    const btnText = `See all ${groupTotal} ${unit}`;

    return (
        <div className="group-results">
            <SectionHeader>Groups ({groupTotal})</SectionHeader>
            <ul>
                {(groups || []).map((group, index) => (
                    <RenderGroup
                        group={group}
                        key={`group-${group.hash}`}
                        index={index}
                    />
                ))}
            </ul>
            <SeeAllButton
                text={btnText}
                type="group"
                url={url}
                isSingleSearch={isSingleSearch}
            />
        </div>
    );
};

export default GroupResults;

GroupResults.propTypes = {
    results: PropTypes.shape({
        results: PropTypes.arrayOf(GroupPropTypesShape),
        total: PropTypes.number,
    }),
    url: PropTypes.string,
    isSingleSearch: PropTypes.bool,
};

GroupResults.defaultProps = {
    results: {
        results: [],
        total: null,
    },
    url: null,
    isSingleSearch: false,
};
